'use strict';

// ── Shopify asset resolution ──────────────────────────────────
// Local-site asset paths are mapped to Shopify CDN URLs via the
// window.ZV_ASSETS map rendered by snippets/zv-assets.liquid.
const zvAsset = path => (window.ZV_ASSETS && window.ZV_ASSETS[path]) || path;
const zvImageSrc = item => zvAsset((item && (item.assetKey || item.src)) || '');
const zvRequiredAssetKey = 'assets/transparent/gold-pendant/A.png';
const zvAssetsReady = () => !!(window.ZV_ASSETS && window.ZV_ASSETS[zvRequiredAssetKey]);
function zvStartWhenAssetsReady(callback, tries = 0) {
  if (zvAssetsReady() || tries >= 80) {
    callback();
    return;
  }
  window.setTimeout(() => zvStartWhenAssetsReady(callback, tries + 1), 50);
}

// ── Data ──────────────────────────────────────────────────────

const BASE_PRICE    = 14.99;
const PRICE_GOLD    = 5;
const PRICE_DIAMOND = 5;
const MAX_GOLD      = 7;
const MAX_DIAMOND   = 14;
const maxPendants   = () => state.style === 'diamond' ? MAX_DIAMOND : MAX_GOLD;

// ── Gold anchor positions ──────────────────────────────────────
const GOLD_ODD_ANCHORS = [
  { xPct: 0.4953, yPct: 0.5847 },
  { xPct: 0.5547, yPct: 0.5816 },
  { xPct: 0.4359, yPct: 0.5785 },
  { xPct: 0.6125, yPct: 0.5676 },
  { xPct: 0.3766, yPct: 0.5613 },
  { xPct: 0.6656, yPct: 0.5441 },
  { xPct: 0.3219, yPct: 0.5347 },
];
const GOLD_EVEN_ANCHORS = [
  { xPct: 0.5328, yPct: 0.5847 },
  { xPct: 0.4703, yPct: 0.5847 },
  { xPct: 0.5938, yPct: 0.5738 },
  { xPct: 0.6500, yPct: 0.5519 },
  { xPct: 0.4156, yPct: 0.5738 },
  { xPct: 0.3563, yPct: 0.5519 },
];

// ── Diamond anchor positions (set via anchor tool) ─────────────
const DIAMOND_ODD_ANCHORS = [
  { xPct: 0.5016, yPct: 0.5863 },
  { xPct: 0.5406, yPct: 0.5847 },
  { xPct: 0.4625, yPct: 0.5832 },
  { xPct: 0.5781, yPct: 0.5769 },
  { xPct: 0.4234, yPct: 0.5754 },
  { xPct: 0.6156, yPct: 0.5660 },
  { xPct: 0.3844, yPct: 0.5644 },
  { xPct: 0.6531, yPct: 0.5519 },
  { xPct: 0.3469, yPct: 0.5488 },
  { xPct: 0.6906, yPct: 0.5332 },
  { xPct: 0.3094, yPct: 0.5301 },
  { xPct: 0.7266, yPct: 0.5097 },
  { xPct: 0.2719, yPct: 0.5082 },
  { xPct: 0.7625, yPct: 0.4894 },
  { xPct: 0.2344, yPct: 0.4847 },
];
const DIAMOND_EVEN_ANCHORS = [
  { xPct: 0.4797, yPct: 0.5855 },
  { xPct: 0.5141, yPct: 0.5855 },
  { xPct: 0.5484, yPct: 0.5840 },
  { xPct: 0.4453, yPct: 0.5808 },
  { xPct: 0.5828, yPct: 0.5777 },
  { xPct: 0.6156, yPct: 0.5668 },
  { xPct: 0.4109, yPct: 0.5746 },
  { xPct: 0.6484, yPct: 0.5543 },
  { xPct: 0.3781, yPct: 0.5637 },
  { xPct: 0.6813, yPct: 0.5418 },
  { xPct: 0.3453, yPct: 0.5543 },
  { xPct: 0.7125, yPct: 0.5215 },
  { xPct: 0.3125, yPct: 0.5340 },
  { xPct: 0.2797, yPct: 0.5152 },
];

// Visible glyph width (fraction of the square canvas) for each Shimmer charm,
// used to pack them edge-to-edge in the nameplate layout.
const DIAMOND_CHARM_WIDTHS = {
  "0":0.697,"1":0.504,"2":0.628,"3":0.607,"4":0.754,"5":0.602,"6":0.626,"7":0.619,"8":0.596,"9":0.649,
  "A":0.612,"B":0.6,"C":0.589,"D":0.668,"E":0.529,"F":0.521,"G":0.726,"H":0.668,"I":0.356,"J":0.52,
  "K":0.67,"L":0.57,"M":0.854,"N":0.685,"O":0.701,"P":0.551,"Q":0.689,"R":0.622,"S":0.57,"T":0.695,
  "U":0.649,"V":0.684,"W":0.848,"X":0.661,"Y":0.662,"Z":0.741,
  "blue-heart":0.873,"dark-blue-heart":0.842,"dark-green-heart":0.848,"green-heart":0.855,
  "light-purple-heart":0.857,"navy-blue-heart":0.843,"pink":0.844,"purple-heart":0.852,
  "red-heart":0.853,"rose-red-heart":0.874,"white-heart":0.849,"yellow-heart":0.845
};

// Pre-sort all sets left → right
const GOLD_ODD_SORTED     = [...GOLD_ODD_ANCHORS].sort((a, b) => a.xPct - b.xPct);
const GOLD_EVEN_SORTED    = [...GOLD_EVEN_ANCHORS].sort((a, b) => a.xPct - b.xPct);
const DIAMOND_ODD_SORTED  = [...DIAMOND_ODD_ANCHORS].sort((a, b) => a.xPct - b.xPct);
const DIAMOND_EVEN_SORTED = [...DIAMOND_EVEN_ANCHORS].sort((a, b) => a.xPct - b.xPct);

// Returns the N center-most anchor positions for a given count and product style.
function getAnchors(n, style) {
  if (n === 0) return [];
  const isOdd = n % 2 === 1;
  const src = style === 'diamond'
    ? (isOdd ? DIAMOND_ODD_SORTED  : DIAMOND_EVEN_SORTED)
    : (isOdd ? GOLD_ODD_SORTED     : GOLD_EVEN_SORTED);
  const skip = (src.length - n) / 2;
  return src.slice(skip, skip + n);
}

const GOLD_LETTERS           = 'ABCDEFGHIKLMNOPQRSTUVWXYZ'.split('');
const DIMOND_PENDANT_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const DIAMOND_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const DIAMOND_NUMBERS = '0123456789'.split('');
const DIAMOND_HEARTS  = [
  { file: 'pink',               label: 'Pink',     name: 'Pink Heart'       },
  { file: 'red-heart',          label: 'Red',      name: 'Red Heart'        },
  { file: 'rose-red-heart',     label: 'Rose',     name: 'Rose Red Heart'   },
  { file: 'blue-heart',         label: 'Blue',     name: 'Blue Heart'       },
  { file: 'dark-blue-heart',    label: 'Dk.Blue',  name: 'Dark Blue Heart'  },
  { file: 'navy-blue-heart',    label: 'Navy',     name: 'Navy Blue Heart'  },
  { file: 'green-heart',        label: 'Green',    name: 'Green Heart'      },
  { file: 'dark-green-heart',   label: 'Dk.Green', name: 'Dark Green Heart' },
  { file: 'yellow-heart',       label: 'Yellow',   name: 'Yellow Heart'     },
  { file: 'purple-heart',       label: 'Purple',   name: 'Purple Heart'     },
  { file: 'light-purple-heart', label: 'Lavender', name: 'Lavender Heart'   },
  { file: 'white-heart',        label: 'White',    name: 'White Heart'      },
];

// ── State ─────────────────────────────────────────────────────
// pendants: ordered array — index 0 = leftmost on chain, last = rightmost.
// Anchor positions are computed from getAnchors(pendants.length) each render.

const state = {
  style:          'gold',
  sub:            'letters',
  pendants:       [],
  history:        [],
  draggingUid:    null,   // uid being dragged (tray or chain)
  dragSource:     null,   // 'tray' | 'chain'
  dragFromPicker: null,   // item being dragged from picker
};

let _uid = 0;
const uid = () => `p${++_uid}_${Date.now()}`;

// ── DOM refs ──────────────────────────────────────────────────

const $ = id => document.getElementById(id);

const charGrid            = $('charGrid');
const chainWrap           = $('chainWrap');
const tray                = $('tray');
const trayEmpty           = $('trayEmpty');
const pendantCountEl      = $('pendantCount');
const undoBtn             = $('undoBtn');
const clearBtn            = $('clearBtn');
const subtabs             = $('subtabs');
const summaryList         = $('summaryList');
const summaryQty          = $('summaryQty');
const summaryPendantTotal = $('summaryPendantTotal');
const summaryTotal        = $('summaryTotal');
const canvas              = $('canvas');
const toast               = $('toast');

// ── Helpers ───────────────────────────────────────────────────

const filledCount = () => state.pendants.length;


// Sets the drag ghost to just the transparent PNG, no element chrome.
function setDragImage(e, src) {
  const img = new Image();
  img.src = src;
  img.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:40px;';
  document.body.appendChild(img);
  e.dataTransfer.setDragImage(img, 20, 20);
  setTimeout(() => img.remove(), 0);
}

// ── State mutations ───────────────────────────────────────────

function saveHistory() {
  state.history.push(state.pendants.map(p => ({ ...p })));
}

function addPendant(item) {
  if (filledCount() >= maxPendants()) {
    showToast(`Maximum ${maxPendants()} charms reached`);
    return;
  }
  saveHistory();
  state.pendants.push({ uid: uid(), ...item });
  render();
}

function removePendant(pUid) {
  const i = state.pendants.findIndex(p => p.uid === pUid);
  if (i === -1) return;
  saveHistory();
  state.pendants.splice(i, 1);
  render();
}
window.removePendant = removePendant;

// Move a pendant to a new position in the array (tray reorder).
// side: 'left' = insert before target, 'right' = insert after target.
function movePendant(fromUid, toUid, side) {
  const fi = state.pendants.findIndex(p => p.uid === fromUid);
  if (fi < 0) return;
  saveHistory();
  const [moved] = state.pendants.splice(fi, 1);
  const ti = state.pendants.findIndex(p => p.uid === toUid);
  if (ti < 0) { state.pendants.push(moved); }
  else { state.pendants.splice(side === 'right' ? ti + 1 : ti, 0, moved); }
  render();
}

function undo() {
  if (!state.history.length) return;
  state.pendants = state.history.pop();
  render();
}

function clearAll() {
  if (!filledCount()) return;
  saveHistory();
  state.pendants = [];
  render();
}

// ── Style / Sub-tab switching ─────────────────────────────────

document.querySelectorAll('.c-style-tab').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.c-style-tab').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    state.style = btn.dataset.style;
    state.pendants = [];
    state.history = [];
    document.getElementById('pendantMax').textContent = maxPendants();
    subtabs.classList.toggle('visible', state.style === 'diamond');
    state.sub = 'letters';
    document.querySelectorAll('.c-subtab').forEach(b =>
      b.classList.toggle('active', b.dataset.sub === 'letters')
    );
    renderPicker();
    render();
  });
});

let _pendingSubBtn = null;

document.querySelectorAll('.c-subtab').forEach(btn => {
  btn.addEventListener('click', () => {
    if (btn.dataset.sub === state.sub) return;
    // Signature page: Gold and Silver are different styles, so switching with
    // charms already placed asks the customer to save or discard first.
    if (window.PRODUCT_STYLE === 'gold' && filledCount() > 0) {
      _pendingSubBtn = btn;
      openSwitchConfirm();
      return;
    }
    switchSub(btn);
  });
});

function switchSub(btn) {
  document.querySelectorAll('.c-subtab').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  state.sub = btn.dataset.sub;
  // On the Signature page, Gold/Silver designs are exclusive — start fresh.
  if (window.PRODUCT_STYLE === 'gold') {
    state.pendants = [];
    state.history = [];
    render();
  }
  renderPicker();
  updateChainArt();
}

// ── Save / discard confirmation when switching Gold <-> Silver ──
function openSwitchConfirm() {
  const m = document.getElementById('switchConfirm');
  if (m) m.hidden = false;
}
function closeSwitchConfirm() {
  const m = document.getElementById('switchConfirm');
  if (m) m.hidden = true;
  _pendingSubBtn = null;
}

document.addEventListener('DOMContentLoaded', wireSwitchConfirm);
wireSwitchConfirm();
function wireSwitchConfirm() {
  const save = document.getElementById('confirmSave');
  const discard = document.getElementById('confirmDiscard');
  if (!save || save.dataset.wired) return;
  save.dataset.wired = '1';
  save.addEventListener('click', () => {
    persistDesign();
    const b = _pendingSubBtn;
    closeSwitchConfirm();
    if (b) switchSub(b);
  });
  discard.addEventListener('click', () => {
    const b = _pendingSubBtn;
    closeSwitchConfirm();
    if (b) switchSub(b);
  });
  document.querySelectorAll('[data-confirm-cancel]').forEach(el =>
    el.addEventListener('click', closeSwitchConfirm)
  );
}

// On the Signature page, the chain is silver under the "Silver" sub-tab and
// gold everywhere else. Other pages keep the gold chain.
function updateChainArt() {
  const silver = window.PRODUCT_STYLE === 'gold' && state.sub === 'diamond-pendant';
  const src = zvAsset(silver ? 'assets/Chain-Silver.png' : 'assets/Chain.png');
  const alt = silver ? 'Silver Necklace Chain' : 'Gold Necklace Chain';
  document.querySelectorAll('.c-chain-img, .c-summary__chain-thumb img').forEach(img => {
    img.src = src;
    img.alt = alt;
  });
  const name = document.getElementById('chainName');
  if (name) name.textContent = silver ? 'Fine Silver Chain' : 'Fine Gold Chain';
}

// ── Picker ────────────────────────────────────────────────────

function renderPicker() {
  charGrid.innerHTML = '';
  charGrid.classList.toggle('sub--diamond-pendant', state.style === 'gold' && state.sub === 'diamond-pendant');
  const atMax = state.pendants.length >= maxPendants();

  getPaletteItems().forEach(item => {
    const el = document.createElement('div');
    el.className = 'c-palette-item' + (atMax ? ' at-max' : '');
    el.draggable = !atMax;
    el.title = item.name;
    el.setAttribute('role', 'listitem');
    el.innerHTML = `
      <div class="c-palette-item__img">
        <img src="${item.src}" alt="${item.label}" loading="lazy" draggable="false">
      </div>
      <span class="c-palette-item__label">${item.label}</span>
    `;

    el.addEventListener('click', () => addPendant(item));

    el.addEventListener('dragstart', e => {
      if (filledCount() >= maxPendants()) { e.preventDefault(); return; }
      state.dragFromPicker = item;
      e.dataTransfer.effectAllowed = 'copy';
      e.dataTransfer.setData('from-picker', '1');
      setDragImage(e, zvImageSrc(item));
      setTimeout(() => el.classList.add('dragging'), 0);
    });
    el.addEventListener('dragend', () => {
      el.classList.remove('dragging');
      state.dragFromPicker = null;
    });

    charGrid.appendChild(el);
  });
}

function getPaletteItems() {
  if (state.style === 'gold') {
    if (state.sub === 'diamond-pendant') {
      return DIMOND_PENDANT_LETTERS.map(l => {
        const assetKey = `assets/transparent/silver/${l}.png`;
        return {
          src: zvAsset(assetKey), assetKey, label: l,
          name: `Silver ${l}`, style: 'gold', price: PRICE_DIAMOND,
        };
      });
    }
    return GOLD_LETTERS.map(l => {
      const assetKey = `assets/transparent/gold-pendant/${l}.png`;
      return {
        src: zvAsset(assetKey), assetKey, label: l,
        name: `Gold ${l}`, style: 'gold', price: PRICE_GOLD,
      };
    });
  }
  if (state.sub === 'letters') {
    return DIAMOND_LETTERS.map(l => {
      const assetKey = `assets/transparent/diamond-letter-and-heart/${l}.png`;
      return {
        src: zvAsset(assetKey), assetKey, label: l,
        name: `Diamond ${l}`, style: 'diamond', price: PRICE_DIAMOND,
      };
    });
  }
  if (state.sub === 'numbers') {
    return DIAMOND_NUMBERS.map(n => {
      const assetKey = `assets/transparent/diamond-letter-and-heart/${n}.png`;
      return {
        src: zvAsset(assetKey), assetKey, label: n,
        name: `Diamond ${n}`, style: 'diamond', price: PRICE_DIAMOND,
      };
    });
  }
  return DIAMOND_HEARTS.map(h => {
    const assetKey = `assets/transparent/diamond-letter-and-heart/${h.file}.png`;
    return {
      src: zvAsset(assetKey), assetKey, label: h.label,
      name: h.name, style: 'diamond', price: PRICE_DIAMOND,
    };
  });
}

// ── Tray ──────────────────────────────────────────────────────

function renderTray() {
  const n = state.pendants.length;
  pendantCountEl.textContent = n;
  undoBtn.disabled  = state.history.length === 0;
  clearBtn.disabled = n === 0;
  trayEmpty.style.display = n === 0 ? 'block' : 'none';

  [...tray.querySelectorAll('.c-tray__item')].forEach(el => el.remove());

  // Tray order matches left-to-right chain order (index 0 = leftmost)
  state.pendants.forEach(pendant => {
    const el = document.createElement('div');
    el.className = 'c-tray__item';
    el.setAttribute('role', 'listitem');
    el.draggable = true;
    el.dataset.uid = pendant.uid;
    el.innerHTML = `
      <img src="${zvImageSrc(pendant)}" alt="${pendant.label}" draggable="false">
      <span class="c-tray__item-label">${pendant.label}</span>
      <button class="c-tray__remove" aria-label="Remove ${pendant.label}">×</button>
    `;

    el.querySelector('.c-tray__remove').addEventListener('click', e => {
      e.stopPropagation();
      removePendant(pendant.uid);
    });

    el.addEventListener('dragstart', e => {
      if (state.dragFromPicker) return;
      state.draggingUid = pendant.uid;
      state.dragSource  = 'tray';
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('reorder-uid', pendant.uid);
      setDragImage(e, zvImageSrc(pendant));
      setTimeout(() => el.classList.add('dragging'), 0);
    });
    el.addEventListener('dragend', () => {
      el.classList.remove('dragging');
      tray.querySelectorAll('.c-tray__item').forEach(t =>
        t.classList.remove('drag-over-left', 'drag-over-right')
      );
      state.draggingUid = null;
      state.dragSource  = null;
    });
    el.addEventListener('dragover', e => {
      e.preventDefault();
      if (state.dragFromPicker) { e.dataTransfer.dropEffect = 'copy'; return; }
      e.dataTransfer.dropEffect = 'move';
      const mid = el.getBoundingClientRect().left + el.offsetWidth / 2;
      tray.querySelectorAll('.c-tray__item').forEach(t =>
        t.classList.remove('drag-over-left', 'drag-over-right')
      );
      el.classList.add(e.clientX < mid ? 'drag-over-left' : 'drag-over-right');
    });
    el.addEventListener('dragleave', () => {
      el.classList.remove('drag-over-left', 'drag-over-right');
    });
    el.addEventListener('drop', e => {
      e.preventDefault();
      e.stopPropagation();
      el.classList.remove('drag-over-left', 'drag-over-right');
      if (state.dragFromPicker) { addPendant(state.dragFromPicker); return; }
      const fromUid = e.dataTransfer.getData('reorder-uid');
      if (fromUid && fromUid !== pendant.uid) {
        const mid  = el.getBoundingClientRect().left + el.offsetWidth / 2;
        const side = e.clientX < mid ? 'left' : 'right';
        movePendant(fromUid, pendant.uid, side);
      }
    });

    tray.appendChild(el);
  });
}

// ── Summary panel ─────────────────────────────────────────────

function renderSummary() {
  const pendants = state.pendants;
  const n = pendants.length;
  summaryQty.textContent = n;

  summaryList.innerHTML = n === 0
    ? '<p class="c-summary__empty">No charms added yet.<br>Browse the palette to start.</p>'
    : pendants.map(p => `
        <div class="c-summary__pendant-row">
          <img src="${zvImageSrc(p)}" alt="${p.label}" class="c-summary__pendant-thumb">
          <div class="c-summary__pendant-info">
            <p class="c-summary__pendant-name">${p.name}</p>
            <p class="c-summary__pendant-price">+$${p.price}.00</p>
          </div>
          <button class="c-summary__remove-btn"
            onclick="removePendant('${p.uid}')"
            aria-label="Remove ${p.label}">×</button>
        </div>
      `).join('');

  const sum = pendants.reduce((s, p) => s + p.price, 0);
  summaryPendantTotal.textContent = sum.toFixed(2);
  summaryTotal.textContent = (BASE_PRICE + sum).toFixed(2);
}

// ── Charm overlay on chain photo ──────────────────────────────

function renderCharmOverlay() {
  let overlay = chainWrap.querySelector('.c-pendant-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'c-pendant-overlay';
    chainWrap.appendChild(overlay);
  }
  overlay.innerHTML = '';

  const W = chainWrap.offsetWidth;
  if (!W) return;

  const n = state.pendants.length;
  const anchors = getAnchors(n, state.style);
  // Shimmer Charm (diamond) = nameplate: charms packed edge-to-edge by their
  // real glyph widths, centered on the chain and following its curve.
  // Gold stays spaced/dangly.
  const CONTIGUOUS = state.style === 'diamond';
  // Shrink the charm box on mobile so the Shimmer nameplate re-packs smaller
  // (tighter + tops still pinned to the chain) instead of overwhelming the chain.
  const BOX = (window.innerWidth <= 640 ? 20 : 26), GAP = 2;   // charm box px + tiny gap between glyphs
  const CURVE_Y0 = 0.586, CURVE_K = 1.44;
  const gw = state.pendants.map(p => {
    const key = ((p.assetKey || p.src) + '').split('/').pop().replace(/\.(png|jpg).*$/i, '');
    return BOX * (DIAMOND_CHARM_WIDTHS[key] || 0.65);
  });
  const totalW = gw.reduce((s, w) => s + w, 0) + GAP * Math.max(0, n - 1);
  let cursor = W * 0.5 - totalW / 2;   // left edge of the first glyph
  state.pendants.forEach((pendant, i) => {
    let x, y;
    if (CONTIGUOUS) {
      const glyphCenter = cursor + gw[i] / 2;
      cursor += gw[i] + GAP;
      const xPct = glyphCenter / W;
      const yPct = CURVE_Y0 - CURVE_K * Math.pow(xPct - 0.5, 2);
      x = glyphCenter - BOX / 2;
      y = (yPct - 1 / 3) * W - 4;
    } else {
      const anchor = anchors[i];
      x = anchor.xPct * W - 13;
      y = (anchor.yPct - 1 / 3) * W - 4;
    }

    const el = document.createElement('div');
    el.className = 'c-chain-pendant';
    el.draggable = true;
    el.style.left = `${x.toFixed(1)}px`;
    el.style.top  = `${y.toFixed(1)}px`;
    el.title = `${pendant.name} — drag to reorder, click to remove`;
    el.innerHTML = `
      <img src="${zvImageSrc(pendant)}" alt="${pendant.label}" draggable="false">
      <span class="c-chain-pendant__remove" aria-hidden="true">×</span>
    `;

    el.addEventListener('dragstart', e => {
      state.draggingUid = pendant.uid;
      state.dragSource  = 'chain';
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('reorder-uid', pendant.uid);
      setDragImage(e, zvImageSrc(pendant));
      setTimeout(() => el.classList.add('dragging'), 0);
    });
    el.addEventListener('dragend', () => {
      el.classList.remove('dragging');
      overlay.querySelectorAll('.c-chain-pendant').forEach(p =>
        p.classList.remove('drag-target')
      );
      state.draggingUid = null;
      state.dragSource  = null;
    });
    el.addEventListener('dragover', e => {
      if (!state.draggingUid || state.draggingUid === pendant.uid) return;
      e.preventDefault();
      e.stopPropagation();
      e.dataTransfer.dropEffect = 'move';
      overlay.querySelectorAll('.c-chain-pendant').forEach(p =>
        p.classList.remove('drag-target')
      );
      el.classList.add('drag-target');
    });
    el.addEventListener('dragleave', () => el.classList.remove('drag-target'));
    el.addEventListener('drop', e => {
      e.preventDefault();
      e.stopPropagation();
      el.classList.remove('drag-target');
      const fromUid = e.dataTransfer.getData('reorder-uid');
      if (fromUid && fromUid !== pendant.uid) {
        const mid  = el.getBoundingClientRect().left + el.offsetWidth / 2;
        const side = e.clientX < mid ? 'left' : 'right';
        movePendant(fromUid, pendant.uid, side);
      }
    });

    el.addEventListener('click', () => removePendant(pendant.uid));
    overlay.appendChild(el);
  });
}

// ── Master render ─────────────────────────────────────────────

// Toggle the "max reached" disabled state on existing palette items without
// rebuilding the grid — so tapping a pendant doesn't reset the picker's scroll.
function updatePickerMaxState() {
  const atMax = state.pendants.length >= maxPendants();
  charGrid.querySelectorAll('.c-palette-item').forEach(el => {
    el.classList.toggle('at-max', atMax);
    el.draggable = !atMax;
  });
}

function render() {
  renderTray();
  renderSummary();
  updatePickerMaxState();
  renderCharmOverlay();
}

window.addEventListener('resize', renderCharmOverlay, { passive: true });


// ── Chain drop zone ───────────────────────────────────────────

chainWrap.addEventListener('dragover', e => {
  if (!state.dragFromPicker) return;
  e.preventDefault();
  e.dataTransfer.dropEffect = 'copy';
  chainWrap.classList.add('drag-over');
});

chainWrap.addEventListener('dragleave', e => {
  if (!chainWrap.contains(e.relatedTarget)) chainWrap.classList.remove('drag-over');
});

chainWrap.addEventListener('drop', e => {
  e.preventDefault();
  chainWrap.classList.remove('drag-over');
  if (!state.dragFromPicker) return;
  addPendant(state.dragFromPicker);
});

// ── Tray drop zone ────────────────────────────────────────────

tray.addEventListener('dragover', e => {
  e.preventDefault();
  e.dataTransfer.dropEffect = state.dragFromPicker ? 'copy' : 'move';
  if (state.dragFromPicker) tray.classList.add('drag-active');
});
tray.addEventListener('dragleave', () => tray.classList.remove('drag-active'));
tray.addEventListener('drop', e => {
  e.preventDefault();
  tray.classList.remove('drag-active');
  if (state.dragFromPicker) addPendant(state.dragFromPicker);
});

// ── Controls ──────────────────────────────────────────────────

undoBtn.addEventListener('click', undo);

// Single tap clears immediately (native confirm() was silently blocked on
// mobile Safari, making the button appear dead). Undo still restores.
clearBtn.addEventListener('click', () => {
  if (!filledCount()) return;
  clearAll();
  showToast('All charms removed — tap Undo to restore');
});

function getDesignSnapshot() {
  const anchors = getAnchors(state.pendants.length, state.style);
  return state.pendants.map((p, i) => ({
    name: p.name, src: p.assetKey || p.src, price: p.price,
    xPct: anchors[i].xPct, yPct: anchors[i].yPct
  }));
}

// ── Shopify cart integration ──────────────────────────────────

function findShopifyVariant(count) {
  const data = window.ZV_SHOPIFY_PRODUCT;
  if (!data || !Array.isArray(data.variants)) return null;
  return data.variants.find(v => Number(v.charm_count) === count) ||
         data.variants.find(v => Number.parseInt(v.option1 || v.title, 10) === count) ||
         null;
}

function getDesignProperties() {
  const design = getDesignSnapshot();
  return {
    'Charm Count': String(design.length),
    'Charm Order': design.map(p => p.name).join(', '),
    'Design Style': window.PRODUCT_STYLE === 'diamond' ? 'Shimmer Charm' : 'Signature Pendant',
    '_ZV Preview': JSON.stringify(design.map(p => ({
      name: p.name,
      src: p.src,
      xPct: p.xPct,
      yPct: p.yPct
    })))
  };
}

async function addShopifyDesignToCart() {
  const count = state.pendants.length;
  const variant = findShopifyVariant(count);
  if (!variant) {
    showToast('Product variants are missing. Import the products CSV first.', 'error');
    return;
  }

  const btn = $('addToCartBtn');
  btn.disabled = true;
  btn.textContent = 'Adding...';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(variant.id),
          quantity: 1,
          properties: getDesignProperties()
        }]
      })
    });
    if (!res.ok) {
      let message = 'Could not add this design.';
      try {
        const error = await res.json();
        message = error.description || error.message || message;
      } catch (e) {}
      throw new Error(message);
    }

    btn.textContent = 'Added to Cart!';
    btn.style.cssText = 'background:#C4964A;border-color:#C4964A;width:100%';
    showToast('Added to cart!', 'gold');
    if (window.updateZivaCartBadge) window.updateZivaCartBadge();
    setTimeout(() => { window.location.href = '/cart'; }, 700);
  } catch (error) {
    console.error(error);
    btn.disabled = false;
    btn.textContent = 'Add to Cart';
    btn.style.cssText = 'width:100%';
    showToast(error.message || 'Could not add this design.', 'error');
  }
}

function doAddToCart() {
  if (state.pendants.length === 0) {
    showToast('Add at least one charm first', 'error');
    return;
  }

  if (window.ZV_SHOPIFY_PRODUCT && Array.isArray(window.ZV_SHOPIFY_PRODUCT.variants)) {
    addShopifyDesignToCart();
    return;
  }

  const btn = $('addToCartBtn');
  btn.textContent = '✓ Added to Cart!';
  btn.style.cssText = 'background:#C4964A;border-color:#C4964A;width:100%';
  showToast('Added to cart! Start your next design.', 'gold');

  try {
    let cart;
    try { cart = JSON.parse(localStorage.getItem('zv_cart') || '[]'); }
    catch (e) { cart = []; }
    cart.push({
      id: Date.now(),
      product: window.PRODUCT_STYLE === 'diamond' ? 'Shimmer Charm Necklace' : 'Signature Pendant Necklace',
      pendants: getDesignSnapshot(),
      basePrice: BASE_PRICE,
      total: parseFloat((BASE_PRICE + state.pendants.reduce((s, p) => s + p.price, 0)).toFixed(2))
    });
    localStorage.setItem('zv_cart', JSON.stringify(cart));
    updateCartBadge();
  } catch (e) { console.error('Cart save failed:', e); }

  setTimeout(() => {
    state.pendants = [];
    state.history = [];
    render();
    btn.textContent = 'Add to Cart';
    btn.style.cssText = 'width:100%';
  }, 1500);
}

$('addToCartBtn').addEventListener('click', doAddToCart);

function updateCartBadge() {
  if (window.updateZivaCartBadge) {
    window.updateZivaCartBadge();
    return;
  }
  let cart;
  try { cart = JSON.parse(localStorage.getItem('zv_cart') || '[]'); }
  catch (e) { cart = []; }
  const count = cart.length;
  document.querySelectorAll('.nav__cart-badge').forEach(el => el.remove());
  if (count > 0) {
    document.querySelectorAll('[aria-label="Cart"]').forEach(link => {
      const badge = document.createElement('span');
      badge.className = 'nav__cart-badge';
      badge.textContent = count;
      link.style.position = 'relative';
      link.appendChild(badge);
    });
  }
}
updateCartBadge();

function persistDesign() {
  let saved;
  try { saved = JSON.parse(localStorage.getItem('zv_saved') || '[]'); }
  catch (e) { saved = []; localStorage.removeItem('zv_saved'); }

  const design = {
    id: Date.now(),
    product: window.PRODUCT_STYLE === 'diamond' ? 'Shimmer Charm Necklace' : 'Signature Pendant Necklace',
    pendants: getDesignSnapshot(),
    basePrice: BASE_PRICE,
    total: parseFloat((BASE_PRICE + state.pendants.reduce((s, p) => s + p.price, 0)).toFixed(2)),
    savedAt: new Date().toLocaleDateString()
  };
  saved.push(design);
  localStorage.setItem('zv_saved', JSON.stringify(saved));
  updateSavedBadge();
  showToast('Design saved!');
}

$('saveBtn').addEventListener('click', () => {
  if (state.pendants.length === 0) {
    showToast('Add at least one charm to save', 'error');
    return;
  }
  persistDesign();
  $('saveBtn').textContent = '✓ Design Saved!';
  setTimeout(() => {
    state.pendants = [];
    state.history = [];
    render();
    $('saveBtn').textContent = 'Save Design';
  }, 1500);
});

function updateSavedBadge() {
  if (window.updateZivaSavedBadge) {
    window.updateZivaSavedBadge();
    return;
  }
  let _s;
  try { _s = JSON.parse(localStorage.getItem('zv_saved') || '[]'); } catch (e) { _s = []; }
  const count = _s.length;
  document.querySelectorAll('.nav__saved-badge').forEach(el => el.remove());
  if (count > 0) {
    document.querySelectorAll('[aria-label="Saved Designs"]').forEach(link => {
      const badge = document.createElement('span');
      badge.className = 'nav__saved-badge nav__cart-badge';
      badge.textContent = count;
      link.style.position = 'relative';
      link.appendChild(badge);
    });
  }
}
updateSavedBadge();

// ── Toast ─────────────────────────────────────────────────────

let toastTimer;
function showToast(msg, variant = '') {
  clearTimeout(toastTimer);
  toast.textContent = msg;
  toast.className = 'c-toast' + (variant ? ` c-toast--${variant}` : '') + ' visible';
  toastTimer = setTimeout(() => toast.classList.remove('visible'), 2800);
}

// ── Init ──────────────────────────────────────────────────────

// Each product page sets window.PRODUCT_STYLE before loading this script
if (window.PRODUCT_STYLE === 'gold' || window.PRODUCT_STYLE === 'diamond') {
  state.style = window.PRODUCT_STYLE;
  document.querySelectorAll('.c-style-tab').forEach(b => {
    b.classList.toggle('active', b.dataset.style === window.PRODUCT_STYLE);
  });
  subtabs.classList.add('visible');
  document.getElementById('pendantMax').textContent = maxPendants();
}

zvStartWhenAssetsReady(() => {
  renderPicker();
  render();
  updateChainArt();
});
